import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../../components";
import "./UnfinalizeInvoiceModal.scss";

class UnfinalizeInvoiceModal extends Component {
	constructor(props) {
		super(props);

		this.initialState = {
			reason: "",
			hasError: false,
		};

		this.state = { ...this.initialState };
	}

	validate = () => {
		const { reason } = this.state;
		const { onSubmit } = this.props;

		if (reason === "") {
			this.setState({ hasError: true });
			return;
		}
		onSubmit(reason);
	};

	render() {
		const { lang } = global;
		const { reason, hasError } = this.state;
		const { show, loading, onCancel } = this.props;

		return (
			<Modal
				id="unfinalize-invoice-modal"
				show={show}
				onHide={onCancel}
				onExited={() => this.setState(this.initialState)}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Un-Finalize Invoice")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div>
						{lang.t(
							'Once "Un-finalized", the invoice will move back into a Pending status, and can be accessed under the "Pending" tab on the Invoice List page',
						)}
					</div>
					<br />
					<label htmlFor="unfinalizeReason">{`${lang.t("Reason for un-finalizing invoice")}?`}</label>
					<div className="row form-group">
						<div className="col-xs-12">
							<input
								type="text"
								id="unfinalizeReason"
								name="unfinalizeReason"
								className={`form-control${hasError ? " has-error" : ""}`}
								value={reason}
								placeholder={lang.t("User needs to add a late fee")}
								onChange={e =>
									this.setState({ reason: e.target.value, hasError: false })
								}
								onKeyPress={({ key }) => {
									if (key === "Enter") this.validate();
								}}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={onCancel}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => this.validate()}
						disabled={loading}
					>
						<Choose>
							<When condition={loading}>
								<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
							</When>
							<Otherwise>{lang.t("Confirm")}</Otherwise>
						</Choose>
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

UnfinalizeInvoiceModal.propTypes = {
	show: PropTypes.bool,
	loading: PropTypes.bool,
	onCancel: PropTypes.func,
	onSubmit: PropTypes.func,
};

UnfinalizeInvoiceModal.defaultProps = {
	show: false,
	loading: false,
	onCancel: () => {},
	onSubmit: () => {},
};

export default UnfinalizeInvoiceModal;
